import app from '@src/helpers/app';
import {shortCode} from '@src/helpers/hash/shortCode';

export function getSearchTermParams(
    controllerName: string,
    searchTerm: string,
    additionalParams: Record<string, string> = {},
): Record<string, string> {
    const key = app('names-resolver').listNames.getSearchTermGetParamName(controllerName);

    return {
        [shortCode(key)]: searchTerm,
        ...additionalParams,
    };
}

export function getSearchTermParamsAsString(
    controllerName: string,
    searchTerm: string,
    additionalParams: Record<string, string> = {}
): string {
    return new URLSearchParams(
        getSearchTermParams(controllerName, searchTerm, additionalParams)
    ).toString();
}
